import { get, set } from 'lodash';

export const FormRadioList = {
  transclude: true,

  bindings: {
    isDisabled: '<',
    form: '<',
    name: '@',
    key: '@',
    value: '<',
    list: '<',
    listItemKey: '@',
    listItemTitle: '@',
    listItemClass: '@',
    required: '@',
    onUpdate: '&',
    isSelectable: '<',
  },

  template: `
    <ul class="list-inline">
      <li
        class="px-1 m-0 {{ $ctrl.listItemClass }}"
        ng-repeat="item in $ctrl.list track by $index">
        <label
          class="d-flex justify-content-center align-items-center py-2 px-3 btn rounded word-wrap"
          ng-class="{
            'theme-mid text-white': item[$ctrl.listItemKey] == $ctrl.value,
            'bg-gray-100': item[$ctrl.listItemKey] != $ctrl.value,
            'disabled text-gray': item.isDisabled || $ctrl.isDisabled,
          }">
          <input class="d-none"
            type="radio"
            name="{{ $ctrl.name }}"
            value="{{ item[$ctrl.listItemKey] }}"
            ng-model="$ctrl.form.data[$ctrl.name]"
            ng-disabled="!$ctrl.isSelectable && (item.isDisabled || $ctrl.isDisabled)"
            ng-required="$ctrl.required"
            ng-click="$ctrl.onUpdate({
              key: $ctrl.key || $ctrl.name,
              value: item[$ctrl.listItemKey],
            })">
          {{ item[$ctrl.listItemTitle] }}
        </label>
      </li>
    </ul>`,

  controller() {
    return {
      $onInit() {
        this.setValue(this.value);
      },

      $onChanges(changes) {
        const newValue = get(changes, 'value.currentValue');
        const oldValue = get(this.form.data, this.name);

        if (newValue && newValue !== oldValue) {
          this.setValue(newValue);
        }
      },

      setValue(value) {
        set(this.form, ['data', this.name], value ? value.toString() : value);
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormRadioList.js